var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "home-container" },
    [
      _c(
        "div",
        { staticClass: "hx-breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { "separator-class": "el-icon-arrow-right" } },
            [
              _c("el-breadcrumb-item", [_vm._v("首页")]),
              _c("el-breadcrumb-item", [_vm._v("供应系统")]),
              _c("el-breadcrumb-item", [_vm._v("商品管理")]),
              _c("el-breadcrumb-item", [_vm._v("实时库存")]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "hx-form-container box-shadow" },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.listParams, "label-width": "100px" } },
            [
              _c(
                "el-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "领货日期：" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                clearable: "",
                                placeholder: "请选择领货日期",
                                size: "small",
                              },
                              model: {
                                value: _vm.listParams.plaSupplyDateId,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.listParams,
                                    "plaSupplyDateId",
                                    $$v
                                  )
                                },
                                expression: "listParams.plaSupplyDateId",
                              },
                            },
                            _vm._l(_vm.dateList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { value: item.id, label: item.title },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small", type: "primary" },
                              on: { click: _vm.loadTableData },
                            },
                            [_vm._v(" 查询 ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "hx-table-result",
        {
          attrs: {
            "show-pager-on-one-page": false,
            "page-info": _vm.pager,
            loading: _vm.tableLoading,
          },
          on: {
            "page-current-change": _vm.handleCurrentChange,
            "page-size-change": _vm.handleSizeChange,
          },
        },
        [
          _c("div", { attrs: { slot: "action" }, slot: "action" }),
          _c("hx-table-result-col", [
            _c(
              "div",
              {
                staticClass: "wrap-table-info-display",
                staticStyle: { height: "32px" },
              },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "align-left",
                    attrs: { size: "small" },
                    on: { click: _vm.outExcel },
                  },
                  [_vm._v(" 导出 ")]
                ),
                _vm.deliveryTakenDate
                  ? _c(
                      "div",
                      {
                        staticClass: "table-info-display",
                        staticStyle: { "font-weight": "600" },
                      },
                      [
                        _c("span", [_vm._v("领货日期：")]),
                        _c("span", { staticClass: "alert-text" }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("formatDate")(_vm.deliveryTakenDate, true)
                            )
                          ),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _c(
            "el-table",
            {
              attrs: {
                slot: "content",
                data: _vm.tableData,
                "max-height": "800",
                border: "",
              },
              slot: "content",
            },
            [
              _c("el-table-column", {
                attrs: { align: "center", width: "60", label: "序号" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", {
                          domProps: {
                            textContent: _vm._s(
                              (_vm.pager.pageIndex > 1
                                ? (_vm.pager.pageIndex - 1) * _vm.pager.pageSize
                                : 0) +
                                scope.$index +
                                1
                            ),
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  fixed: "",
                  width: "120",
                  prop: "title",
                  align: "center",
                  label: "产品名称",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  fixed: "",
                  prop: "spec",
                  align: "center",
                  label: "规格",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  fixed: "",
                  width: "120",
                  prop: "ability",
                  align: "center",
                  label: "基地供应能力",
                },
              }),
              _vm._l(_vm.columnList, function (item, index1) {
                return _c(
                  "el-table-column",
                  {
                    key: index1,
                    attrs: { align: "center", label: item.title },
                  },
                  _vm._l(item.secondTitle, function (item2, index2) {
                    return _c("el-table-column", {
                      key: index2,
                      attrs: { width: "150", align: "center", label: item2 },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _vm._l(
                                  row.baseList,
                                  function (tableItem, index3) {
                                    return _c(
                                      "div",
                                      {
                                        key: index3,
                                        staticClass: "line-height-style",
                                        attrs: {
                                          title: tableItem[index1][index2],
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(tableItem[index1][index2]) +
                                            " "
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                index2 == 1
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.serach(item.id, row.id)
                                          },
                                        },
                                      },
                                      [_vm._v("等级库存实时查询")]
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    })
                  }),
                  1
                )
              }),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showInventory,
            loading: _vm.inventoryLoading,
            "before-close": _vm.closeInventory,
            width: "30%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showInventory = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "inventoryForm",
              attrs: { model: _vm.listParams, "label-width": "220px" },
            },
            [
              _vm._l(
                _vm.inventoryForm,
                function (inventoryItem, ininventoryIndex) {
                  return [
                    _c(
                      "el-form-item",
                      { attrs: { label: inventoryItem.levelName + ":" } },
                      [
                        _vm._v(_vm._s(inventoryItem.stock) + " "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.addInventory(
                                  inventoryItem.levelSalesId
                                )
                              },
                            },
                          },
                          [_vm._v(" 追加库存")]
                        ),
                      ],
                      1
                    ),
                  ]
                }
              ),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.btnLoading,
              expression: "btnLoading",
            },
          ],
          attrs: {
            title: "追加库存",
            width: "30%",
            visible: _vm.innerVisible,
            "append-to-body": "",
            "modal-append-to-body": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.innerVisible = $event
            },
          },
        },
        [
          [
            _c(
              "el-form",
              { attrs: { inline: "" } },
              _vm._l(_vm.inventoryList, function (item) {
                return _c(
                  "div",
                  [
                    _c("el-form-item", { attrs: { label: "基地:" } }, [
                      _vm._v(" " + _vm._s(item.farmName) + " "),
                    ]),
                    _c("el-form-item", { attrs: { label: "库存:" } }, [
                      _vm._v(" " + _vm._s(item.currentStock) + " "),
                    ]),
                    _c(
                      "el-form-item",
                      { attrs: { label: "追加库存:" } },
                      [
                        _c("el-input-number", {
                          attrs: { min: 0, max: 10, label: "请输入追加数目" },
                          model: {
                            value: item.appendStock,
                            callback: function ($$v) {
                              _vm.$set(item, "appendStock", $$v)
                            },
                            expression: "item.appendStock",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
              0
            ),
          ],
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.innerVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    disabled: _vm.btnLoading,
                    loading: _vm.btnLoading,
                  },
                  on: { click: _vm.submitInventoryList },
                },
                [_vm._v("提交")]
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }